import React, { Component } from "react";
import {
  Col,
  Button,
  Row,
  FormGroup,
  Popover,
  Modal,
  ModalBody,
  Media,
  timeoutsShape,
  Input,
} from "reactstrap";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import Select from "react-select";
import {
  UserRole,
  UserRoles,
  roleOptions,
  dynamic_urls,
  renderGenderPronoun,
  profilePicValidityCheck,
  isTrivvyUrl,
  manageRoleText,
  formatPhoneNumber,
} from "../../../../utils/constants";
import warningIcon from "../../../../assets/warning.svg";
import UserIcon1 from "../../../../assets/user-image-plc/User_Icon_1.svg";
import UserIcon2 from "../../../../assets/user-image-plc/User_Icon_2.svg";
import UserIcon3 from "../../../../assets/user-image-plc/User_Icon_3.svg";
import UserIcon4 from "../../../../assets/user-image-plc/User_Icon_4.svg";
import UserIcon5 from "../../../../assets/user-image-plc/User_Icon_5.svg";
import "./OfficeMate.css";
import InfoMessage from "../../../../components/Message/InfoMessage/InfoMessage";
import { isMobile } from "../../../../utils/deviceInfo";
import If from "../../../../components/Shared/If";
import { getFlatDataFromTree } from "react-sortable-tree";
import { BiEditAlt, BiEnvelope, BiMailSend, BiMessage } from "react-icons/bi";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import ReactTooltip from "react-tooltip";
import { toastContainer } from "../../../../utils/toast";
import { BsFillCheckCircleFill } from "react-icons/bs";
import moment from "moment";
import CheckBox from "rc-checkbox";
import { MdOutlineMobileFriendly } from "react-icons/md";
import { EMPTY_VALUE_LABEL } from "../../../../utils/constants";

export default class OfficeMate extends Component {
  // {'officeName': this.props.officeMate.officeId.name,
  //             'officeHierarchyPath': this.props.officeMate.officeId.officeHierarchyPath}
  constructor(props) {
    super(props);
    this.state = {
      officeMateRole: {
        key: manageRoleText(this.props.officeMate),
        value: manageRoleText(this.props.officeMate),
      },
      selectedOffice:
        this.props.officeMate &&
        this.props.officeMate.officeId &&
        this.props.officeMate.officeId !== null
          ? {
              officeName: this.props.officeMate.officeId.name,
              officeHierarchyPath: this.props.officeMate.officeId
                .officeHierarchyPath,
            }
          : null,
      removeUserPopoverOpen: false,
      showRemoveUserConfirmationModal: false,
      showAddMember: false,
      allOfficesWithInvitations: [],
      editPhoneNumberOpen: false,
      officeMateMobileNumber: this.props.officeMate.mobileNumber,
      editEmailOpen: false,
      officeMateEmail: this.props.officeMate.email,
      editNameOpen: false,
      officeMateFirstName: this.props.officeMate.firstName,
      officeMateLastName: this.props.officeMate.lastName,
    };

    // console.log(this.props)
  }

  componentWillReceiveProps(nextProps) {
    //this.props.officeMate.role && this.props.officeMate.orgAdmin?'Enterprise Admin':this.props.officeMate.role
    this.setState({
      officeMateRole: {
        key: manageRoleText(nextProps.officeMate),
        value: manageRoleText(nextProps.officeMate),
      },
      // Only update email if not currently editing it
      ...(!this.state.editEmailOpen && {
        officeMateEmail: nextProps.officeMate.email,
      }),
      // Only update mobile number if not currently editing it
      ...(!this.state.editPhoneNumberOpen && {
        officeMateMobileNumber: nextProps.officeMate.mobileNumber,
      }),
      ...(this.state.officeMateFirstName === this.props.officeMate.firstName && {
        officeMateFirstName: nextProps.officeMate.firstName,
      }),
      ...(this.state.officeMateLastName === this.props.officeMate.lastName && {
        officeMateLastName: nextProps.officeMate.lastName,
      }),
    });
  }

  handleRoleChange = (role) => {
    if (this.props.changeToAdminDisabled && role.value == "Admin") {
      return;
    }

    // Block role change to Admin/EA for users without a real email on file.
    const targetIsAdminOrEA = role.value === "Admin" || role.orgAdmin === true;
    const officeMate = this.props.officeMate;
    const hasNoEmail =
      !officeMate.email ||
      officeMate.email.toString().trim() === "" ||
      officeMate.isDummyEmail === true;
    if (targetIsAdminOrEA && hasNoEmail) {
      toastContainer(
        "You must first add an Email for a User, before changing their role to EA or Admin.",
        "error"
      );
      return;
    }

    let payload = {
      role: role.value,
      currentRole: this.props.officeMate.role,
      orgAdmin: role.orgAdmin,
    };
    console.log(this.props);
    console.log(role, this.props.officeMate);
    // if(this.props.officeMate.role==="Member"){
    //     let office= {
    //         officeName: this.props.user.officeId.name,
    //         officeHierarchyPath: this.props.user.officeHierarchyPath
    //     }
    //     this.setState({selectedOffice:office})
    // } else if (role.value==="Member"){

    //     this.setState({selectedOffice:null})
    // }
    this.setState({ selectedOffice: null });

    axios
    .put(url.changeRole(this.props.officeMate._id), payload)
    .then((data) => {
      this.props.onRoleChange({
        _id: this.props.officeMate._id,
        role: role.value,
        orgAdmin: role.orgAdmin,
        previousRole: this.props.officeMate.role,
        officeId: this.props.user.officeId,
        officeHierarchyPath: this.props.user.officeHierarchyPath,
      });

      // Notify if user changed to Admin/EA and hasn't registered yet
      var isAdminOrEA = role.value === "Admin" || role.orgAdmin === true;
      var hasNotRegistered = !this.props.officeMate.isPasswordChanged;
      if (isAdminOrEA && hasNotRegistered) {
        toastContainer(
          "Remember to use Invite by Email in the dropdown to ensure the user registers and can perform their role on the platform.",
          "info"
        );
      }
    })
    .catch((error) => {
      console.log("Change Role Error");
    });
  };

  handleOfficeChange = (office) => {
    // console.log(office)

    this.setState({
      selectedOffice: office,
    });
    let payload = {
      userId: this.props.officeMate._id,
      office,
      orgId: this.props.officeMate.organizationId,
    };
    axios
      .post(url.changeUserOffice, payload)
      .then((data) => {
        let user = data.data.data;
        this.props.onOfficeChange(user);
      })
      .catch((error) => {
        console.log("Change Role Error");
      });
  };

  removeOfficeMate = () => {
    axios
      .delete(url.removeOfficeMate + this.props.officeMate._id)
      .then(() => {
        this.props.onUserRemoved();
      })
      .catch(() => {
        console.log("Change Role Error");
      });
  };

  toggleRemoveUserPopover = () => {
    this.setState({
      removeUserPopoverOpen: !this.state.removeUserPopoverOpen,
    });
  };

  navigateToProfile = (profilePicSrc) => {
    // console.log(this.props)

    if (isMobile) return;
    let link = "";
    let profileURL = dynamic_urls(
      this.props.officeMate,
      this.props.officeMate.organizationId
    ).my_profile;

    if (this.props.user._id === this.props.officeMate._id) {
      this.props.history.push({
        pathname: profileURL,
      });
    } else {
      // /:orgId/profile/:id
      this.props.history.push({
        pathname: profileURL,
        // `/home/${this.props.officeMate.organizationId}/profile/${this.props.officeMate._id}`
        state: {
          officeMate: this.props.officeMate,
          profilePicSrcIndex: profilePicValidityCheck(
            this.props.officeMate.profilePic
          )
            ? -1
            : this.props.rowIndex % 3,
        },
      });
    }
  };

  addOfficeMate = (user) => {
    // console.log(user)
    // this.setState({showAddMember: true})
    axios
      .post(url.addMemberInOffice, user)
      .then((data) => {
        let newrole = data.data.role;
        // console.log(data)
        this.props.onRoleChange({
          _id: this.props.officeMate._id,
          role: "User",
        });
        this.setState({ showAddMember: false });
      })
      .catch((error) => {
        console.log("Change Role Error");
      });
  };

  // renderUserOffices = (officeMate) =>{
  //     let {user, allOfficesWithInvitations} = this.props
  //     let {selectedOffice} = this.state
  //     // console.log(user.role, user)
  //     if(user.orgAdmin){
  //         return(<Col sm={3} className="d-flex align-items-center">
  //             <div style={{ width: '100%' }}>
  //                 <Select
  //                     name="role-select"
  //                     value={selectedOffice}
  //                     placeholder="Select Office"
  //                     onChange={(office) => this.handleOfficeChange(office)}
  //                     options={allOfficesWithInvitations}
  //                     valueKey='officeHierarchyPath'
  //                     labelKey='officeName'
  //                     clearable={false}
  //                 />
  //             </div>
  //         </Col>)
  //     } else if(!user.orgAdmin && user.role=="Admin"){
  //         if(officeMate.orgAdmin || officeMate._id===user._id){
  //             return (<Col sm={3} className="d-flex align-items-center">
  //                 {selectedOffice && selectedOffice.officeName!==null? selectedOffice.officeName: "No Office Selected"}
  //             </Col>)
  //         } else if(officeMate.role!=="Member") {
  //             return (
  //             <Col sm={3} className="d-flex align-items-center">
  //                                 {selectedOffice && selectedOffice.officeName!==null? selectedOffice.officeName: "No Office Selected"}

  //                 {/* <div style={{ width: '100%' }}>
  //                     <Select
  //                         name="role-select"
  //                         value={selectedOffice}
  //                         placeholder="Select Office"
  //                         onChange={(office) => this.handleOfficeChange(office)}
  //                         options={allOfficesWithInvitations}
  //                         valueKey='officeHierarchyPath'
  //                         labelKey='officeName'
  //                         clearable={false}
  //                     />
  //                 </div>                     */}
  //             </Col>)
  //         } else {
  //             return(
  //             <Col sm={3} className="d-flex align-items-center">
  //             {selectedOffice && selectedOffice.officeName!==null? selectedOffice.officeName: "No Office Selected"}
  //             </Col>)
  //         }
  //     } else {
  //         return (
  //             <Col sm={3} className="d-flex align-items-center">
  //                 {selectedOffice && selectedOffice.officeName!==null? selectedOffice.officeName: "No Office Selected"}
  //             </Col>
  //         )
  //     }
  // }

  showUserRoles = (officeMateRole) => {
    const { user } = this.props;
    if (user.role === "Admin" && user.orgAdmin) {
      return roleOptions;
    }

    if (user.role === "Admin" && !user.orgAdmin) {
      // Cannot demote an Admin
      if (officeMateRole === "Admin") {
        return roleOptions.filter((e) => e.value !== "Enterprise Admin" && e.value !== "User");
      }
      return roleOptions.filter((e) => e.value !== "Enterprise Admin");
    }

    return [];
  };

  saveOfficeMateMobileNumber = () => {
    axios
      .put(url.changeMobileNumber(this.props.officeMate._id), {
        mobileNumber: this.state.officeMateMobileNumber || "",
      })
      .then((data) => {
        if (this.props.handleMobileNumberChange) {
          this.props.handleMobileNumberChange({
            _id: this.props.officeMate._id,
            mobileNumber: this.state.officeMateMobileNumber || "",
          });
        }
        toastContainer("Mobile number updated successfully", "success");
        this.setState({
          editPhoneNumberOpen: false,
        });
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  saveOfficeMateEmail = () => {
    axios
      .put(url.changeEmailId(this.props.officeMate._id), {
        email: this.state.officeMateEmail || "",
      })
      .then((data) => {
        const updatedUser = data.data;
        if (this.props.handleEmailChange) {
          this.props.handleEmailChange({
            _id: this.props.officeMate._id,
            email: this.state.officeMateEmail || "",
            isDummyEmail: updatedUser.data.isDummyEmail,
          });
        }
        toastContainer("Email saved successfully", "success");
        this.setState({
          editEmailOpen: false,
        });
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  saveOfficeMateNames = () => {
    axios
      .put(url.changeUserNames(this.props.officeMate._id), {
        firstName: this.state.officeMateFirstName,
        lastName: this.state.officeMateLastName,
      })
      .then((data) => {
        if (this.props.handleNameChange) {
          this.props.handleNameChange({
            _id: this.props.officeMate._id,
            firstName: this.state.officeMateFirstName,
            lastName: this.state.officeMateLastName,
          });
        }
        toastContainer("Name saved successfully", "success");
        this.setState({
          editNameOpen: false,
        });
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  reInviteViaEmail = () => {
    const { officeMate } = this.props;
    axios
      .post(url.reInviteUsers, {
        user: officeMate,
        inviteViaEmail: true,
      })
      .then(({ data }) => {
        if (this.props.handleInviteDateChange) {
          this.props.handleInviteDateChange(data.data);
        }
        toastContainer("Invited successfully", "success");
      })
      .catch((err) => {
        toastContainer("Error while inviting user", "error");
      });
  };

  reInviteViaSMS = () => {
    const { officeMate } = this.props;
    axios
      .post(url.reInviteUsers, {
        user: officeMate,
        inviteViaSMS: true,
      })
      .then(({ data }) => {
        if (this.props.handleInviteDateChange) {
          this.props.handleInviteDateChange(data.data);
        }
        toastContainer("Invited successfully", "success");
      })
      .catch((err) => {
        toastContainer("Error while inviting user", "error");
      });
  };

  render() {
    let userPicPlaceholders = [
      UserIcon1,
      UserIcon2,
      UserIcon3,
      UserIcon4,
      UserIcon5,
    ];
    let {
      officeMate,
      userRole,
      rowIndex,
      user,
      allOfficesWithInvitations,
      userSelectedForRemove,
      removeChecked,
    } = this.props;
    // console.log(officeMate,'----',selectedOffice)

    let {
      removeUserPopoverOpen,
      selectedOffice,
      showRemoveUserConfirmationModal,
      officeMateRole,
      showAddMember,
      editPhoneNumberOpen,
      officeMateMobileNumber,
      editEmailOpen,
      officeMateEmail,
      editNameOpen,
      officeMateFirstName,
      officeMateLastName,
    } = this.state;
    let roleView = null;
    let moreView = null;
    let officeMateImageView = null;
    let disableRoleChange = true;
    if (officeMate._id === this.props.user._id || user) {
      disableRoleChange = true;
    }
    if (user.orgAdmin) {
      disableRoleChange = false;
    }

    if (
      user.role === "Admin" &&
      user.officeId &&
      officeMate.officeId &&
      user.officeId._id.toString() === officeMate.officeId.toString() &&
      !officeMate.orgAdmin
    ) {
      disableRoleChange = false;
    }

    if (profilePicValidityCheck(officeMate.profilePic)) {
      officeMateImageView = (
        <img src={officeMate.profilePic} className="officemate-img" />
      );
    } else {
      let picPlaceholderSrc = userPicPlaceholders[rowIndex % 3];
      officeMateImageView = (
        <img src={picPlaceholderSrc} className="officemate-img" />
      );
    }

    if (userRole != "") {
      if (this.props.user.role !== "Member") {
        // console.log('officeM---', officeMate)

        const currentUser = this.props.user;
        const targetUser = this.props.officeMate;

        const isEnterpriseAdmin = currentUser.role === "Admin" && currentUser.orgAdmin;
        const isRegularAdmin = currentUser.role === "Admin" && !currentUser.orgAdmin;
        const isTargetAdmin = targetUser.role === "Admin";
        const isTargetOrgAdmin = targetUser.orgAdmin;

        // Enterprise Admin — can edit anyone
        const showDropdown =
          isEnterpriseAdmin ||
          (isRegularAdmin && !isTargetAdmin); // Regular Admins can only edit non-admins

        roleView = showDropdown ? (
          <div style={{ width: "100%" }}>
            <Select
              name="role-select"
              value={officeMateRole}
              onChange={(role) => this.handleRoleChange(role)}
              options={this.showUserRoles(officeMateRole)}
              valueKey="key"
              labelKey="value"
              clearable={false}
              disabled={false}
            />
          </div>
        ) : (
          <div style={{ width: "100%" }}>
            {manageRoleText(targetUser)}
          </div>
        );

        moreView =
          !disableRoleChange && !isMobile ? (
            user.orgAdmin && officeMate._id != user._id ? (
              <div>
                <i
                  className="flaticon-menu cursor-pointer"
                  style={{ color: "#C3C4C7" }}
                  id={"removeUserPopover" + officeMate._id}
                  onClick={() => {
                    this.setState((state) => ({
                      removeUserPopoverOpen: !state.removeUserPopoverOpen,
                    }));
                  }}
                ></i>
                <Popover
                  placement="bottom-end"
                  className="top-dd-bg1 remove-officemate"
                  isOpen={removeUserPopoverOpen}
                  target={"removeUserPopover" + officeMate._id}
                  toggle={() => {
                    this.setState((state) => ({
                      removeUserPopoverOpen: !state.removeUserPopoverOpen,
                    }));
                  }}
                >
                  <div className="remove-popover-wrapper">
                    <div
                      className="remove-user-txt"
                      onClick={() => {
                        this.setState((state) => ({
                          showRemoveUserConfirmationModal: !state.showRemoveUserConfirmationModal,
                          removeUserPopoverOpen: !state.removeUserPopoverOpen,
                        }));
                      }}
                    >
                      <span
                        className="flaticon-minus user-minus-icon"
                        style={{ marginRight: "11px" }}
                      ></span>
                      <span className="remove-txt">
                        Remove from Organization
                      </span>
                    </div>

                    {!officeMate.isPasswordChanged && (
                      <div
                        className="remove-user-txt"
                        onClick={() => {
                          this.reInviteViaEmail();
                        }}
                      >
                        <BiEnvelope />
                        <span className="remove-txt ml-2">
                          Invite via Email
                        </span>
                      </div>
                    )}
                    {!officeMate.isPasswordChanged &&
                    officeMate.mobileNumber ? (
                      <div
                        className="remove-user-txt"
                        onClick={() => {
                          this.reInviteViaSMS();
                        }}
                      >
                        <BiMessage />
                        <span className="remove-txt ml-2">Invite via SMS</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Popover>
              </div>
            ) : null
          ) : null;
      } else {
        console.log(this.props, "---officeM---", officeMate);
        roleView = (
          <div style={{ width: "100%" }}>{manageRoleText(this.props.officeMate)}</div>
        );
        moreView =
          !disableRoleChange && !isMobile && user.orgAdmin ? (
            <div>
              <i
                className="flaticon-menu cursor-pointer"
                style={{ color: "#C3C4C7" }}
                id={"removeUserPopover" + officeMate._id}
                onClick={() => {
                  this.setState((state) => ({
                    removeUserPopoverOpen: !state.removeUserPopoverOpen,
                  }));
                }}
              ></i>
              <Popover
                placement="bottom-end"
                className="top-dd-bg1 remove-officemate"
                isOpen={removeUserPopoverOpen}
                target={"removeUserPopover" + officeMate._id}
                toggle={() => {
                  this.setState((state) => ({
                    removeUserPopoverOpen: !state.removeUserPopoverOpen,
                  }));
                }}
              >
                <div className="remove-popover-wrapper">
                  <span
                    className="remove-user-txt d-flex justify-content-center"
                    onClick={() => {
                      this.setState((state) => ({
                        showRemoveUserConfirmationModal: !state.showRemoveUserConfirmationModal,
                        removeUserPopoverOpen: !state.removeUserPopoverOpen,
                      }));
                    }}
                  >
                    <span
                      className="flaticon-minus user-minus-icon"
                      style={{ marginRight: "11px" }}
                    ></span>
                    <span className="remove-txt">
                      Remove from Organization{" "}
                    </span>
                  </span>
                </div>
              </Popover>
            </div>
          ) : null;
      }
    } else if (
      userRole !== UserRole.admin &&
      officeMate.role === UserRole.admin &&
      officeMate.role !== "Member"
    ) {
      roleView = <div className="user-office-role">Admin</div>;
    }

    const formHeight = isMobile ? "45px" : "90px";
    // console.log(this.props.allOfficesWithInvitations)

    const modalUI = () => {
      return (
        <div>
          <Modal isOpen={showRemoveUserConfirmationModal}>
            <ModalBody>
              <Row>
                <Col sm={{ size: 12 }} md={{ size: 12 }}>
                  <div className="remove-officemate-modal-title">
                    Remove Member
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={{ size: 12 }} md={{ size: 12 }}>
                  <div className="remove-officemate-modal-note">
                    <div style={{ fontSize: "18px", lineHeight: "24px" }}>
                      <img
                        src={warningIcon}
                        style={{ width: "20px", marginBottom: "4px" }}
                      />
                      <span style={{ marginLeft: "15px" }}>Important Note</span>
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        marginLeft: "35px",
                        lineHeight: "24px",
                      }}
                    >
                      Removing an Enterprise Member will deny them access to the
                      platform. You can always invite them back, but their
                      account will be reset.
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="row mt30">
                <div
                  className="offset-md-1 col-sm-5 col-md-5"
                  style={{ marginLeft: "24px" }}
                >
                  <Button
                    className="remove-officmate-button"
                    onClick={() => this.removeOfficeMate()}
                  >
                    <span className="remove-officemate-modal-btn-txt">
                      Remove Member
                    </span>
                  </Button>{" "}
                </div>
                <div className="col-sm-3 col-md-3">
                  <Button
                    className="cancel-button"
                    onClick={() => {
                      this.setState((state) => ({
                        showRemoveUserConfirmationModal: !state.showRemoveUserConfirmationModal,
                      }));
                    }}
                  >
                    <span className="remove-officemate-modal-cancel-btn-txt">
                      Cancel
                    </span>
                  </Button>
                </div>
              </div>
            </ModalBody>
          </Modal>

          <Modal isOpen={showAddMember}>
            <ModalBody>
              <div className="row">
                <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 pick-office-modal-body-title">
                  Add {officeMate.firstName} {officeMate.lastName} to Your
                  Office
                </div>
              </div>
              <div className="row mt10">
                <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 col-md-offset-right-1 archive-modal-msg">
                  You are about to add {officeMate.firstName}{" "}
                  {officeMate.lastName} to Your Office. Please confirm this
                  action.
                </div>
              </div>
              <div className="row mt30">
                <div className="offset-md-1 col-sm-10 col-md-10">
                  <InfoMessage
                    iconLeft=""
                    msg="Important Note."
                    subMsg="Once added, this member will have all the permissions that users in your office have."
                  />
                </div>
              </div>
              <div className="row mt30">
                <div className="offset-md-1 col-sm-5 col-md-5">
                  <Button
                    onClick={() => this.addOfficeMate(officeMate)}
                    className="float-right invite-button-bg w100"
                  >
                    <span className="archiveBtnTxt">Add Member to Office</span>
                  </Button>
                </div>
                <div className="col-sm-3 col-md-3">
                  <Button
                    className="float-left goBackBtn w100"
                    onClick={() => {
                      this.setState({ showAddMember: false });
                    }}
                  >
                    <span className="goBackBtnTxt">Cancel</span>
                  </Button>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
      );
    };

    return (
        <FormGroup
          style={{ height: formHeight }}
          className="mlmr0 officemate-row"
          row
        >
          <Col
            xs={3}
            sm={3}
            className={` d-flex align-items-center cursorPointer`}
          >
            {officeMate &&
            !officeMate.orgAdmin &&
            this.props.user.role == "Admin" &&
            this.props.user._id != officeMate._id ? (
              <CheckBox
                className="mr-2"
                checked={removeChecked}
                onChange={() => {
                  if (userSelectedForRemove) {
                    userSelectedForRemove(officeMate._id);
                  }
                }}
              />
            ) : (
              <CheckBox
                className="mr-2"
                style={{
                  visibility: "hidden",
                }}
              />
            )}
            <div
              className="align-items-center mlmr0 d-flex flex-fill"
              onClick={!editNameOpen ? this.navigateToProfile : undefined}
            >
              <div className="flex-shrink-1">{officeMateImageView}</div>
              <div
                className="flex-fill ml20 cursor-pointer"
                style={{  wordBreak: "break-word" }}
              >
                <React.Fragment>
                  {officeMate.firstName || officeMate.lastName ||editNameOpen  ? (
                  <div>
                    {editNameOpen &&
                      <div onClick={(e) => e.stopPropagation()}>
                        <div className="d-flex">
                          <Input
                            placeholder="First Name"
                            value={officeMateFirstName || ""}
                            onChange={(e) => {
                              this.setState({
                                officeMateFirstName: e.target.value,
                              });
                            }}
                            onClick={(e) => e.stopPropagation()}
                            className="mr-2"
                          />
                          <Input
                            placeholder="Last Name"
                            value={officeMateLastName || ""}
                            onChange={(e) => {
                              this.setState({
                                officeMateLastName: e.target.value,
                              });
                            }}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        <div className="mt-2">
                          <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              this.saveOfficeMateNames();
                            }}
                            color="success"
                            className="ml-2"
                            size="sm"
                          >
                            Save
                          </Button>{" "}
                          <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              this.setState({ editNameOpen: false });
                            }}
                            color="danger"
                            className="ml-2"
                            size="sm"
                          >
                            Close
                          </Button>
                        </div>
                      </div>}
                   
                  </div>
                ) : (
                  <span className="officemate-email">{EMPTY_VALUE_LABEL}</span>
                )}

                 {!editNameOpen&&<span>
                        <span className="d-flex align-items-center">
                          <span className="officemate-firstname">
                            {this.state.officeMateFirstName&&this.state.officeMateFirstName !== undefined ? this.state.officeMateFirstName : (officeMate.firstName || "")}
                            <span className={(this.state.officeMateFirstName !== undefined ? this.state.officeMateFirstName : officeMate.firstName) ? "ml5" : ""} />
                            <span className="officemate-lastname">
                              {this.state.officeMateLastName&&this.state.officeMateLastName !== undefined ? this.state.officeMateLastName : (officeMate.lastName || "")}
                            </span>
                          </span>
                          {officeMate.isPasswordChanged && (
                            <span className="ml-2 d-flex align-items-center flex-shrink-0">
                              <BsFillCheckCircleFill size={14} color="green" />
                            </span>
                          )}
                        </span>
                      </span>}
                </React.Fragment>
                

<div className="users_gp_members">
                      {renderGenderPronoun(officeMate)}
                      {!officeMate.isPasswordChanged &&
                      officeMate.lastInvitedAt ? (
                        <span>
                          (last invited{" "}
                          {moment(officeMate.lastInvitedAt).format(
                            "MMM DD, YYYY"
                          )}
                          {officeMate.lastInviteVia &&
                          Array.isArray(officeMate.lastInviteVia) &&
                          officeMate.lastInviteVia.length ? (
                            <span className="ml-1" style={{ fontSize: "15px" }}>
                              {officeMate.lastInviteVia.includes("EMAIL") && (
                                <BiMailSend />
                              )}{" "}
                              {officeMate.lastInviteVia.includes("SMS") && (
                                <MdOutlineMobileFriendly />
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          )
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
              </div>
              {!editNameOpen && (((this.props.user._id == officeMate._id) && this.props.user.role === "Admin") || this.props.user.orgAdmin || ((this.props.user.role === "Admin") && (officeMateRole.value === "User"))) && (
                <BiEditAlt
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      editNameOpen: true,
                      officeMateFirstName: this.state.officeMateFirstName || "",
                      officeMateLastName: this.state.officeMateLastName || "",
                    });
                  }}
                  className="ml-auto flex-shrink-0 cursor-pointer"
                />
              )}
            </div>
          </Col>

            <Col
              xs={2}
              sm={2}
              className={` d-flex align-items-center`}
            >
              {editEmailOpen ? (
                <div>
                  <Input
                    value={officeMateEmail}
                    onChange={(e) => {
                      this.setState({
                        officeMateEmail: e.target.value,
                      });
                    }}
                  />
                  <div className="mt-2">
                    <Button
                      onClick={this.saveOfficeMateEmail}
                      color="success"
                      className="ml-2"
                      size="sm"
                    >
                      Save
                    </Button>{" "}
                    <Button
                      onClick={() => this.setState({ editEmailOpen: false })}
                      color="danger"
                      className="ml-2"
                      size="sm"
                    >
                      Close
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-end w-100">
                  <span
                    className="font-13px"
                    style={{ wordBreak: "break-all" }}
                    data-tip={officeMate.isDummyEmail ? EMPTY_VALUE_LABEL : officeMate.email}
                  >
                    {officeMate.isDummyEmail ? EMPTY_VALUE_LABEL : officeMate.email}
                  </span>
                  {(((this.props.user._id == officeMate._id) && this.props.user.role === "Admin") || this.props.user.orgAdmin || ((this.props.user.role === "Admin") && (officeMateRole.value === "User"))) && (
                    <BiEditAlt
                      onClick={() =>
                        this.setState({
                          editEmailOpen: true,
                          officeMateEmail:
                            officeMate.isDummyEmail
                              ? ""
                              : officeMate.email,
                        })
                      }
                      className="ml-3 cursor-pointer"
                    />
                  )}
                </div>
              )}

              <ReactTooltip />
            </Col>
            <Col
              xs={2}
              sm={2}
              className={` d-flex align-items-center`}
            >
              {/* {(((this.props.user._id == officeMate._id) && this.props.user.role === "Admin") || this.props.user.orgAdmin || ((this.props.user.role === "Admin") && (officeMateRole.value === "User"))) && ( */}
              {userRole.toLowerCase().includes('admin') && (

                <div className="w-100">
                  {editPhoneNumberOpen ? (
                    <div className="">
                      <PhoneInputWithCountrySelect
                        placeholder="Enter Mobile number"
                        value={officeMateMobileNumber}
                        onChange={(v) =>{
                         
                          this.setState({
                            officeMateMobileNumber: formatPhoneNumber(v),
                          })
                        }
                        }
                        className="form-control p-0"
                        defaultCountry="US"
                        style={{
                          width: "200px",
                        }}
                      />
                      <div className="mt-2">
                        <Button
                          onClick={this.saveOfficeMateMobileNumber}
                          color="success"
                          className="ml-2"
                          size="sm"
                        >
                          Save
                        </Button>{" "}
                        <Button
                          onClick={() =>
                            this.setState({ editPhoneNumberOpen: false })
                          }
                          color="danger"
                          className="ml-2"
                          size="sm"
                        >
                          Close
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-end">
                      <span
                        style={{
                          wordBreak: "break-all",
                          fontSize: "13px",
                        }}
                      >
                        {officeMate.mobileNumber &&
                        profilePicValidityCheck( officeMateMobileNumber ? officeMateMobileNumber : officeMate.mobileNumber)
                          ? officeMateMobileNumber ? officeMateMobileNumber : officeMate.mobileNumber
                          : EMPTY_VALUE_LABEL}
                      </span>
                      {(((this.props.user._id == officeMate._id) && this.props.user.role === "Admin") || this.props.user.orgAdmin || ((this.props.user.role === "Admin") && (officeMateRole.value === "User"))) && (
                        <BiEditAlt
                          onClick={() =>
                            this.setState({ editPhoneNumberOpen: true })
                          }
                          className="ml-3 cursor-pointer"
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
              {/* )} */}
            </Col>

            <Col xs={2} sm={2} className="d-flex align-items-center justify-content-center">
              {userRole.toLowerCase().includes('admin') && (
                <span className="font-13px" style={{ wordBreak: "break-all" }}>
                  {officeMate.createDate
                    ? moment(officeMate.createDate).format("MMM Do, YYYY")
                    : EMPTY_VALUE_LABEL}
                </span>
              )}
            </Col>

            <Col xs={2} sm={2} className="d-flex align-items-center">
              {roleView}
            </Col>
            {/* {this.renderUserOffices(officeMate)} */}

          <Col
            xs={1}
            sm={1}
            className="d-flex align-items-center justify-content-center"
          >
            {moreView}
          </Col>
          {modalUI()}
        </FormGroup>
      );
  }
}
